import {translateUi} from "../../i18n/translateUi"

interface DeliveryCenterPageDecisionParams {
    page: number
    totalPages: number
    pageSize: number
    receivedCount: number
    previousOrderCount: number
    currentOrderCount: number
    totalElements: number
    success: boolean
}

export interface DeliveryCenterPageDecision {
    shouldContinue: boolean
    error?: string
}

export const getDeliveryCenterPageDecision = ({
    page,
    totalPages,
    pageSize,
    receivedCount,
    previousOrderCount,
    currentOrderCount,
    totalElements,
    success
}: DeliveryCenterPageDecisionParams): DeliveryCenterPageDecision => {
    if (!success) {
        return {shouldContinue: false}
    }

    if (!receivedCount && currentOrderCount < totalElements) {
        return {
            shouldContinue: false,
            error: translateUi("Сервер вернул неполный список заказов")
        }
    }

    if (receivedCount < pageSize || page >= totalPages) {
        return {shouldContinue: false}
    }

    if (currentOrderCount === previousOrderCount) {
        return {
            shouldContinue: false,
            error: translateUi("Сервер повторил страницу заказов; синхронизация остановлена")
        }
    }

    return {shouldContinue: true}
}
